<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-14 16:46:42
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-12 11:35:48
-->
<template>
  <div class="select-box">
    <el-input
      placeholder="请选择所属组织"
      class="selectTree-input"
      auto-complete="off"
      v-model="form.input1"
      @click.native="!isDisable?changeSelectTree():''"
      @blur="hideParentClick"
      :disabled="isDisable"
    >
    </el-input>
    <i v-if="!isShowSelect"  class="el-icon-arrow-down icon"></i>
    <i v-if="isShowSelect"  class="el-icon-arrow-up icon"></i>
    <el-tree
      id="floatTree"
      v-if="!isDisable"
      v-show="isShowSelect"
      empty-text="暂无数据"
      :highlight-current="true"
      :default-expand-all="false"
      :expand-on-click-node="true"
      :data="data"
      node-key="value"
      :default-expanded-keys="defaultSelect"
      :filter-node-method="filterNode"
      @node-click="selectClassfy"
      class="selectTree-input objectTree"
      ref="selectTree"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      isShowSelect: false,
      defaultSelect: [],
      form: {
        input1: "",
      },
    };
  },
  props: ["resData", "record",'isDisable'],
  watch: {
    form: {
      handler(form) {
        if (this.isShowSelect) {
          this.$refs.selectTree.filter(form.input1);
        }
      },
      deep: true, //深度监听，重要
    },
  },
  mounted() {
    this.list();
    if (this.record) {
      this.selectClassfy({
        label: this.record.parentName ||  this.record.organizationName,
        value: this.record.parentId,
      });
      this.$nextTick(()=>{
        this.defaultSelect.push(this.record.parentId);
      })
      this.$nextTick(() => {
	       // treeBox 元素的ref   value 绑定的node-key
	      this.$refs.selectTree.setCurrentKey(this.record.parentId); 
	 });
    }
  },
  methods: {
    list() {
      let options = JSON.stringify(this.resData)
        .replace(/organizationName/g, "label")
        .replace(/id/g, "value")
      this.data = JSON.parse(options);
    },
    selectClassfy(data) {
      console.log(data,'dsadas')
      this.form.input1 = data.label;
      this.isShowSelect = false;
      this.$emit("selectpart", data);
    },
    changeSelectTree() {
      this.isShowSelect = true;
    },
    hideParentClick(e) {
      var isOther =
        e.relatedTarget == null ||
        e.relatedTarget.closest("div.el-tree") == null ||
        e.relatedTarget.closest("div.el-tree").id != "floatTree";

      if (isOther) {
        this.isShowSelect = false;
      } else {
        e.target.focus();
      }
    },
    // 选择器的树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="less" scoped>
/*下拉框选择树*/
.objectTree {
  position: absolute;
  overflow: auto;
  z-index: 100;
  height: 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  width: 100%;
}
/deep/ .el-tree-node__expand-icon {
  font-size: 14px;
  font-weight: 600;
}
.icon{
  position: absolute;
  right: 9px;
  top: 15px;
}
</style>